<h3 mat-dialog-title>{{data.title}}</h3>
<div mat-dialog-content>
  <div>{{data.message}}</div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions class="async-alert-actions">
  <button mat-raised-button (click)="onYesClick()" color="accent" >Ok</button>
</div>
